import { render, staticRenderFns } from "./SimpleExperience.vue?vue&type=template&id=675af9ac&scoped=true"
import script from "./SimpleExperience.vue?vue&type=script&lang=js"
export * from "./SimpleExperience.vue?vue&type=script&lang=js"
import style0 from "./SimpleExperience.vue?vue&type=style&index=0&id=675af9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675af9ac",
  null
  
)

export default component.exports